// extracted by mini-css-extract-plugin
export default {"rootClassName":"generic-icon"};